import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import GoodsIn from '../../api/controllers/GoodsIn/GoodsIn';
import GoodsOut from '../../api/controllers/GoodsOut/GoodsOut';
import Error from '../../common/Error/Error';
import Header from '../../common/Header/Header';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';
import SymbolKey from '../../common/SymbolKey/SymbolKey';
import CompletedMovement from '../CompletedMovement/CompletedMovement';
import InProgressJob from '../InProgressJob/InProgressJob';
import InProgressOverview from '../InProgressOverview/InProgressOverview';
import PendingMovement from '../PendingMovement/PendingMovement';
import './Movement.scss';
import { getCategory, getMovementType } from './MovementUtils';

// Movement Screen Component
const Movement = () => {
  const [movement, setMovement] = useState();
  const [status, setStatus] = useState();
  const [category, setCategory] = useState();
  const [fromPending, setFromPending] = useState(false);
  const [error, setError] = useState();
  const [loading, setLoading] = useState();
  const [qrResponse, setQRResponse] = useState();

  const location = useLocation();
  const movementType = getMovementType(location.pathname.split('/')[1]);

  //Most users will get to the movement page from the index page but if they just arrive from a url we want to work out the movement from the url
  const getMovement = async () => {
    const category = getCategory(location.pathname.split('/')[1]);
    setLoading(true);
    if (movementType == 'collections' || movementType == 'imports') {
      GoodsIn.show(category, location.pathname.split('/')[2])
        .then(response => {
          setLoading(false);
          setMovement(response);
          setCategory(category);
          setStatus(
            response?.warehouseData?.confirmed != null
              ? response?.warehouseData?.confirmed
                ? 'complete'
                : 'in_progress'
              : 'not_in_warehouse',
          );
        })
        .catch(e => {
          setLoading(false);
          setError(e.errors || e.error);
        });
    } else {
      GoodsOut.show(category, location.pathname.split('/')[2])
        .then(response => {
          setLoading(false);
          setMovement(response);
          setCategory(category);
          setStatus(
            response?.warehouseData?.confirmed != null
              ? response?.warehouseData?.confirmed
                ? 'complete'
                : 'in_progress'
              : 'not_in_warehouse',
          );
        })
        .catch(e => {
          setLoading(false);
          setError(e.errors || e.error);
        });
    }
  };

  useEffect(() => {
    getMovement();
  }, [location]);

  useEffect(() => {
    setFromPending(false);
  }, [status]);

  const getTitle = () => {
    switch (movementType) {
      case 'collections':
        return `Domestic Collection for ${movement?.assignments[0]?.job?.jobReference}`;
      case 'deliveries':
        return status == 'complete'
          ? `Domestic Delivery for ${movement?.assignments[0]?.job?.jobReference}`
          : null;
      case 'imports':
        return movement?.reference || '(No Groupage)';
      case 'exports':
        return status == 'complete' ? movement?.reference || '(No Groupage)' : null;
    }
  };

  const getExpectedScreen = () => {
    switch (status) {
      case 'not_in_warehouse':
        return (
          <PendingMovement
            setFromPending={setFromPending}
            movement={movement}
            getMovement={getMovement}
            setLoading={setLoading}
            setError={setError}
            movementType={movementType}
            category={category}
          />
        );
      case 'in_progress':
        return category == 'international' ? (
          <InProgressOverview
            fromPending={fromPending}
            movement={movement}
            getMovement={getMovement}
            setLoading={setLoading}
            setError={setError}
            qrResponse={qrResponse}
            movementType={movementType}
            category={category}
          />
        ) : (
          <InProgressJob
            fromPending={fromPending}
            movement={movement}
            getMovement={getMovement}
            setLoading={setLoading}
            setError={setError}
            qrResponse={qrResponse}
            assignment={movement?.assignments[0]}
            movementType={movementType}
            category={category}
          />
        );
      case 'complete':
        return (
          <CompletedMovement
            movement={movement}
            getMovement={getMovement}
            setLoading={setLoading}
            setError={setError}
            movementType={movementType}
            category={category}
          />
        );
    }
  };

  return (
    <div className="movement_screen">
      <Header
        hideQR={movementType == 'collections' || movementType == 'imports' || status == 'complete'}
        leftButton={'back'}
        title={getTitle()}
        rightButton={'home'}
        onScan={status == 'in_progress' ? setQRResponse : null}
      />
      <div className="movement_container">
        {loading && <LoadingSpinner />}
        {error && (
          <Error
            errorMessages={error}
            type={'error'}
            errorTitle={
              Array.isArray(error)
                ? `${error.length} error${error.length > 1 ? 's' : ''} occurred: `
                : ''
            }
          />
        )}
        {getExpectedScreen()}
        {category == 'international' && <SymbolKey />}
      </div>
    </div>
  );
};

export default Movement;
